import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap, retry } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { LottoProduzione } from '../_models/lotto-produzione';
import { StatoLottoProduzione } from '../_models/stato-lotto-produzione';
import { Utils } from '../utils';
import { LottoProduzioneRef } from '../_models/lotto-produzione-ref';
import { retryWhen } from 'rxjs/operator/retryWhen';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class LottoProduzioneService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "LottoProduzioneService";
  }

  /** GET LottoProduzione by id. Will 404 if id not found */
  getElencoLottiProduzione(statoLotto: number[], numeroLottoSpedizione: string, tipoProdotto: string): Observable<LottoProduzioneRef[]> {
    let url = `${ServicesConstants.URL_LOTTIPRODUZIONE}`;

    let prms = [];
    if (statoLotto != null) prms.push("statoLotto=" + statoLotto);
    if (numeroLottoSpedizione != null) prms.push("numeroLottoSpedizione=" + numeroLottoSpedizione);
    if (tipoProdotto != null) prms.push("tipoProdotto=" + tipoProdotto);

    if (prms.length > 0) {
      url = url + "/?" + prms.join("&");
    }
    
    return this.http.get<LottoProduzioneRef[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Lotti Produzione ${prms.join(", ")}`)),
      catchError(this.handleError<LottoProduzioneRef[]>(`getElencoLottiProduzione ${prms.join(", ")}`))
    );
  }

  /** GET LottoProduzione by id. Will 404 if id not found */
  getLottoProduzione(id: number): Observable<LottoProduzione> {
    const url = `${ServicesConstants.URL_LOTTIPRODUZIONE}/${id}`;
    return this.http.get<LottoProduzione>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Lotto Produzione Locale id=${id}`)),
      catchError(this.handleError<LottoProduzione>(`getLottoProduzione id=${id}`))
    );
  }

  /** GET LottoProduzione by id. Will 404 if id not found */
  getElencoStoricoStati(id: number): Observable<StatoLottoProduzione[]> {
    let url = `${ServicesConstants.URL_LOTTIPRODUZIONE}/${id}/stati`;

    return this.http.get<StatoLottoProduzione[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Storico Stati Produzione id=${id}`)),
      catchError(this.handleError<StatoLottoProduzione[]>(`getElencoStoricoStati id=${id}`))
    );
  }

  /** POST: add a new Documento to the server */
  uploadCsvDatiLottoProduzione(lotto: LottoProduzione, file: any): Observable<LottoProduzione> {
    let url = `${ServicesConstants.URL_LOTTIPRODUZIONE}/${lotto.idLottoProduzione}?cmd=uploadCsvDatiProduzione`;

    let formdata: FormData = new FormData();

    formdata.append('csvDatiProduzione', file, Utils.getEncodedFilename(file.name));
    formdata.append('lottoProduzioneBean', new Blob([JSON.stringify(lotto)], { type: "application/json" }));

    return this.http.put<LottoProduzione>(url, formdata).pipe(
      tap((lotto: LottoProduzione) => this.log(`uploaded csv Lotto w/ id=${lotto.idLottoProduzione}`)),
      catchError(this.handleError<LottoProduzione>('uploadCsvDatiLottoProduzione'))
    );
  }



  //////// Save methods //////////
  /** POST: add a new LottoProduzione to the server */
  /*
    addLottoProduzione(LottoProduzione: LottoProduzione): Observable<LottoProduzione> {
      return this.http.post<LottoProduzione>(ServicesConstants.URL_LOTTIPRODUZIONE, LottoProduzione, this.httpOptions).pipe(
        tap((LottoProduzione: LottoProduzione) => this.log(`added LottoProduzione Locale w/ id=${LottoProduzione.idLottoProduzione}`)),
        catchError(this.handleError<LottoProduzione>('addLottoProduzione'))
      );
    }
  */
  /** DELETE: delete the LottoProduzione from the server */

  /*  deleteLottoProduzione(LottoProduzione: LottoProduzione | number): Observable<LottoProduzione> {
      const id = typeof LottoProduzione === 'number' ? LottoProduzione : LottoProduzione.idLottoProduzione;
      const url = `${ServicesConstants.URL_LOTTIPRODUZIONE}/${id}`;
  
      return this.http.delete<LottoProduzione>(url, this.httpOptions).pipe(
        tap(_ => this.log(`deleted LottoProduzione Locale id=${id}`)),
        catchError(this.handleError<LottoProduzione>('deleteLottoProduzione'))
      );
    }
  */

  /** PUT: update the LottoProduzione on the server */
  /*  
    updateLottoProduzione(LottoProduzione: LottoProduzione | number): Observable<any> {
      const id = typeof LottoProduzione === 'number' ? LottoProduzione : LottoProduzione.idLottoProduzione;
      const url = `${ServicesConstants.URL_LOTTIPRODUZIONE}/${id}`;
  
      return this.http.put(url, LottoProduzione, this.httpOptions).pipe(
        tap(_ => this.log(`updated LottoProduzione Locale id=${id}`)),
        catchError(this.handleError<any>('updateLottoProduzione'))
      );
    }
  */

}


// WEBPACK FOOTER //
// ./src/app/_services/lotto-produzione.service.ts